import isEqual from 'lodash/isEqual';

/**
 * The operator config keys that belong to the web chat widget: the backend's
 * `Tour_Operator.WEB_WIDGET_CONFIG_KEYS` (demo/models.py, CP-8187), gated on `web_widget.write`
 * rather than `tour_operator.write`. `web_chat_widget_available` (the platform gate) is not one:
 * the dashboard can never write it.
 */
export const WEB_WIDGET_CONFIG_KEYS = Object.freeze([
  'web_chat_widget',
  'web_chat_widgets',
  'web_chat_widget_enabled',
  'web_chat_widget_idle_timeout_hours',
  'chatbot_prompt_web_widget',
  'ai_auto_reply_min_confidence_web_widget',
  'ai_auto_reply_fallback_message_web_widget',
  'pause_chatbot_for_x_minutes_after_manual_response_web_widget',
  'pause_chatbot_after_handoff_web_widget',
  'web_widget_contact_capture',
  'web_widget_contact_capture_outside_office_hours_only',
  'web_widget_contact_request_message',
  'web_widget_contact_thanks_message',
  'web_widget_contact_confirmation_email',
  'web_inquiry_intake_confirmation_email',
]);

/**
 * The Web Chat Widget page's PUT /tour_operator/{id}/ body: `{config: {...}}` with the widget keys
 * whose value differs from the last saved operator, and nothing else (backend plan
 * 2026-10-29-sandbox-default-tag-categories-sync, WP-H). The backend refuses any other body from a
 * user without `tour_operator.write`, and widget-only users hold `web_widget.write` alone. It merges
 * `config` key by key, so keys left out keep their stored value. A nested blob (`web_chat_widget`,
 * `web_chat_widgets`) goes whole.
 */
export const webWidgetSavePayload = (config, savedConfig) => {
  const now = config || {};
  const saved = savedConfig || {};
  const changed = {};
  WEB_WIDGET_CONFIG_KEYS.forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(now, key)) return;
    if (!Object.prototype.hasOwnProperty.call(saved, key) || !isEqual(now[key], saved[key])) {
      changed[key] = now[key];
    }
  });
  return { config: changed };
};
